if (!customElements.get('pebble-set-components')) {
  customElements.define('pebble-set-components', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const {signal} = this.abort;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.scroller = this.querySelector('[data-scroller]');
      this.accent = this.querySelector('[data-accent]');
      this.original = this.accent?.textContent;
      this.index = 0;
      this.querySelector('[data-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1), {signal});
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), {signal});
      this.scroller.addEventListener('scroll', () => this.schedule(), {signal, passive:true});
      // Horizon can scroll its page wrapper instead of window; capture both.
      document.addEventListener('scroll', () => this.schedule(), {signal, passive:true, capture:true});
      this.resize = new ResizeObserver(() => {this.measure();this.schedule();});
      this.resize.observe(this); this.resize.observe(this.querySelector('.tmr-set__intro'));
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-card]');
        if (!card) return;
        if (this.mobile) this.scroller.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'});
        else card.scrollIntoView({block:'center',behavior:'auto'});
      }, {signal});
      this.measure(); this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);this.animation?.cancel();}
    measure(){
      this.mobile = this.getBoundingClientRect().width <= 700;
      const intro = this.querySelector('.tmr-set__intro');
      const header = parseFloat(getComputedStyle(this).getPropertyValue('--header-height')) || 80;
      // A tall editor configuration must never hide the set CTA above the viewport.
      this.toggleAttribute('data-tall', !this.mobile && intro.offsetHeight > innerHeight-header-20);
      this.style.setProperty('--set-center-height', this.querySelector('.tmr-set__center').offsetHeight + 'px');
    }
    schedule(){if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});}
    update(){
      if(!this.cards.length)return;
      const origin = this.scroller.getBoundingClientRect().left;
      let distance=Infinity,index=0;
      this.cards.forEach((card,i)=>{const r=card.getBoundingClientRect();const d=this.mobile?Math.abs(r.left-origin):Math.abs(r.top+r.height/2-innerHeight/2);if(d<distance){distance=d;index=i;}});
      this.index=index;
      const count=this.querySelector('[data-count]');const text=`${index+1} / ${this.cards.length}`;
      if(count && count.textContent!==text)count.textContent=text;
      const prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
      if(prev)prev.disabled=index===0;if(next)next.disabled=index===this.cards.length-1;
      const phrase=this.cards[index].dataset.phrase || this.original;
      if(this.accent && this.dataset.motion==='true' && phrase && phrase!==this.accent.textContent){
        this.animation?.cancel();this.accent.textContent=phrase;
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches)this.animation=this.accent.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:350,easing:'cubic-bezier(.3,1,.3,1)'});
      }
    }
    move(direction){if(!this.cards.length)return;const i=Math.max(0,Math.min(this.cards.length-1,this.index+direction));this.scroller.scrollTo({left:this.cards[i].offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  });
}
